import { ColaboradorModel } from '@/store/catalogos/colaborador.model';
import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Util } from '@/utils/util';
import { AfterViewInit, Component, HostBinding, OnInit, Renderer2, } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdmSeleccionarSucursalComponent } from '@modules/admin/adm-seleccionar-sucursal/adm-seleccionar-sucursal.component';
import { Store } from '@ngrx/store';
import { ApiService } from '@services/api.service';
import { AppService } from '@services/app.service';
import { AdmPerfilPantallaService, MenuItem } from '@services/admin/adm-perfil-pantalla.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit, AfterViewInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user;
    public menu;
    sesion: ColaboradorModel;
    autoOcultarMenu: boolean;
    photo: string = "assets/img/default-profile.png";
    constructor(
        public appService: AppService, 
        private store: Store<AppState>,
        private apiService: ApiService, 
        private toastr: ToastrService,
        public dialog: MatDialog, 
        private router: Router,
        private util: Util, 
        private renderer: Renderer2,
        private perfilPantallaService: AdmPerfilPantallaService
    ) {
    }

    mostrarSelectorSucursal() {
        let rowCopy = Object.assign({}, this.util.getSesion());
        const dialogRef = this.dialog.open(AdmSeleccionarSucursalComponent, {
            width: '500px', data: { tipo: rowCopy.tipo, row: rowCopy }
        });
        console.log('MOSTRAR MODAL', this.util.getSesion());
        dialogRef.afterClosed().subscribe(result => {
            if (result?.success) {
                // Actualizar sesión en memoria
                this.sesion = this.util.getSesion();
                this.sesion.sucursal = result.data;
                
                // Guardar sesión actualizada (ahora actualiza ambos: 'colaborador' y 'usuario')
                this.util.setSesion(this.sesion);
                
                console.log('Sucursal actualizada correctamente:', result.data);
                
                // Recargar página para reflejar cambios
                location.reload();
            }
        });
    }

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
        });
        this.user = this.appService.user;

        // Cargar menú desde el backend (dinámico basado en permisos)
        this.loadMenu();

        this.autoOcultarMenu = JSON.parse(localStorage.getItem("autoOcultarMenu"));
        this.sesion = this.util.getSesion();

        // COMENTADO: Ya no sobrescribimos con menú estático
        // El menú ahora viene dinámicamente del backend según los permisos del usuario
        /*
        switch(this.sesion.tipo+""){
            case "0":
                this.menu =MENU_1;
                break;
            case "1":
                this.menu =MENU_1;
                break;
            case "2":
                this.menu = MENU_2;
                break;
            default:
                break;
        }
        */
    }

    ngAfterViewInit() {
        this.sesion = this.util.getSesion();
        switch (this.sesion.tipo) {
            case 0:
                let cambioSucursal = sessionStorage.getItem("sucursalCambiada");
                const THIS = this;
                if (this.util.isEmpty(cambioSucursal)) {
                    setTimeout(function () {
                        sessionStorage.setItem('sucursalCambiada', '1');
                        THIS.mostrarSelectorSucursal();
                    }, 500);
                }
                break;
            case 1:
                break;
            case 2:
                break;
            default:
                break;
        }
    }

    async loadMenu() {
        // Usar el nuevo endpoint que obtiene pantallas del usuario autenticado automáticamente
        this.perfilPantallaService.getPantallasUsuarioActual().subscribe({
            next: (response) => {
                console.log('Menú cargado desde nuevo endpoint:', response);
                
                if (response.success && response.data) {
                    // Transformar la estructura MenuItem[] a la estructura del menú que espera el componente
                    this.menu = this.transformarMenu(response.data);
                    localStorage.setItem("menu", JSON.stringify(this.menu));
                    
                    console.log('Menú transformado:', this.menu);
                    console.log('Perfiles del usuario:', response.meta?.perfiles);
                    console.log('Total pantallas asignadas:', response.meta?.total_pantallas);
                } else {
                    console.warn('No se obtuvieron datos del menú');
                    this.usarMenuFallback();
                }
            },
            error: (error) => {
                console.error('Error al cargar menú desde nuevo endpoint:', error);
                this.toastr.error('Error al cargar el menú del usuario');
                this.usarMenuFallback();
            }
        });
    }

    /**
     * Transformar estructura MenuItem[] a estructura del menú legacy
     * MenuItem -> { name, iconClasses, type, path, children }
     */
    private transformarMenu(items: MenuItem[]): any[] {
        return items.map(item => {
            const menuItem: any = {
                name: item.nombre,
                iconClasses: item.icono,
                type: item.es_modulo ? 'padre' : 'link'
            };
            
            // Solo agregar path si no es módulo y tiene ruta
            if (!item.es_modulo && item.ruta) {
                // Convertir string "/catalogos/empresa" a array ['/catalogos/empresa']
                menuItem.path = [item.ruta];
            }
            
            // Procesar children recursivamente, pero solo incluir los asignados
            if (item.children && item.children.length > 0) {
                // Filtrar solo las pantallas asignadas o los módulos padres que tengan hijos asignados
                const childrenTransformados = this.transformarMenu(item.children);
                const childrenAsignados = childrenTransformados.filter(child => {
                    // Incluir si es un link (pantalla asignada) o si es padre con hijos
                    return child.type === 'link' || (child.type === 'padre' && child.children && child.children.length > 0);
                });
                
                if (childrenAsignados.length > 0) {
                    menuItem.children = childrenAsignados;
                }
            }
            
            return menuItem;
        }).filter(item => {
            // Solo incluir en el resultado final:
            // - Links (pantallas asignadas)
            // - Padres que tengan children
            return item.type === 'link' || (item.type === 'padre' && item.children && item.children.length > 0);
        });
    }

    /**
     * Usar menú estático como fallback en caso de error
     */
    private usarMenuFallback() {
        this.sesion = this.util.getSesion();
        console.log('Usando menú estático como fallback para tipo:', this.sesion.tipo);
        
        switch (this.sesion.tipo + "") {
            case "0":
                this.menu = MENU_1;
                break;
            case "1":
                this.menu = MENU_1;
                break;
            case "2":
                this.menu = MENU_2;
                break;
            default:
                this.menu = MENU_1;
                break;
        }
    }

    ocultarMenu() {
        this.util.ocultarMenu(this.renderer);
    }

    changeOcultarMenu() {
        console.log("autoOcultarMenu ", this.autoOcultarMenu);
        localStorage.setItem("autoOcultarMenu", this.autoOcultarMenu + "");
        this.util.autoOcultarMenu(this.renderer);
    }

}

export const MENU_1 = [
    {
        name: 'Administrador',
        iconClasses: 'fas fa-tachometer-alt',
        type: 'padre',
        children: [
            {
                name: 'Empresa',
                type: 'link',
                iconClasses: 'far fa-building',
                path: ['/catalogos/empresa']
            },
            {
                name: 'Sucursal',
                type: 'link',
                iconClasses: 'far fa-building',
                path: ['/catalogos/sucursal']
            },
            {
                type: 'link',
                name: 'Responsable Sucursal',
                iconClasses: 'far fa-address-book',
                path: ['/catalogos/responsable-sucursal']
            },
            {
                type: 'link',
                name: 'Escolaridad',
                iconClasses: 'far fa-address-book',
                path: ['/catalogos/escolaridad']
            },
            {
                type: 'link',
                name: 'Puesto',
                iconClasses: 'far fa-briefcase',
                path: ['/catalogos/puesto']
            },
            {
                type: 'link',
                name: 'Tipo Pago',
                iconClasses: 'far fa-credit-card-alt',
                path: ['/catalogos/tipo-pago']
            },
            {
                type: 'link',
                name: 'Descuentos',
                iconClasses: 'far fa-percent',
                path: ['/catalogos/descuento']
            },
            {
                type: 'link',
                name: 'Grupos',
                iconClasses: 'far fa-address-book',
                path: ['/adm/grupo']
            },
            {
                type: 'link',
                name: 'Parametro',
                iconClasses: 'far fa-address-book',
                path: ['/adm/parametros']
            },
            {
                type: 'link',
                name: 'Gestión Perfiles',
                iconClasses: 'fas fa-user-shield',
                path: ['/adm/perfiles']
            },
            {
                type: 'link',
                name: 'Usuarios',
                iconClasses: 'fas fa-user-shield',
                path: ['/adm/usuarios']
            }

        ]
    },
    {
        name: 'Catalogos',
        type: 'padre',
        iconClasses: 'fas fa-folder',
        children: [
            {
                type: 'link',
                name: 'Colaboradores',
                iconClasses: 'fas fa-users',
                path: ['/catalogos/colaborador']
            },
            {
                type: 'link',
                name: 'Especialidad',
                iconClasses: 'far fa-graduation-cap',
                path: ['/catalogos/especialidad']
            },
            {
                type: 'link',
                name: 'Certificación',
                iconClasses: 'far fa-certificate',
                path: ['/catalogos/certificacion']
            },
            {
                type: 'link',
                name: 'Producto',
                iconClasses: 'far fa-address-book',
                path: ['/catalogos/producto']
            },
            {
                type: 'link',
                name: 'Existencia Producto',
                iconClasses: 'far fa-circle',
                path: ['/catalogos/existencia-producto']
            },
            {
                type: 'link',
                name: 'Alumnos',
                iconClasses: 'far fa-user',
                path: ['/catalogos/alumno']
            },
            {
                type: 'link',
                name: 'Días Festivos',
                iconClasses: 'far fa-calendar',
                path: ['/catalogos/dias-festivos']
            }
        ]
    },
    {
        type: 'padre',
        name: 'Proceso',
        iconClasses: 'far fa-folder',
        children: [
            {
                type: 'link',
                name: 'Incripcion',
                iconClasses: 'fas fa-users',
                path: ['adm/inscripcion']
            },
            {
                type: 'link',
                name: 'Cobro',
                iconClasses: 'fas fa-dollar',
                path: ['adm/cobro']
            },
            {
                type: 'link',
                name: 'Cancelar Pago',
                iconClasses: 'fas fa-dollar',
                path: ['adm/cancelar-pago/0']
            },
            {
                type: 'link',
                name: 'Catalogo Cursos',
                iconClasses: 'fas fa-list-check',
                path: ['adm/catalogo-cursos']
            },
            {
                type: 'link',
                name: 'Baja Alumno/Inscripción',
                iconClasses: 'fas fa-user-times',
                path: ['adm/cancelar-inscripcion']
            },
            {
                type: 'link',
                name: 'Ajustar Colegiatura',
                iconClasses: 'fas fa-dollar',
                path: ['adm/ajuste-colegiatura']
            },
            {
                type: 'link',
                name: 'Recalcular Calendario',
                iconClasses: 'fas fa-calendar',
                path: ['adm/recalcular-calendario']
            },/*
            {
                name: 'Baja Alumno',
                iconClasses:'fas fa-user-times',
                path: ['adm/baja-alumno']
            },*/
            {
                type: 'link',
                name: 'Cambio de Grupo',
                iconClasses: 'fas fa-random',
                path: ['adm/cambio-grupo']
            }
        ]
    },
    {
        type: 'padre',
        name: 'Reportes',
        iconClasses: 'far fa-folder',
        children: [
            {
                type: 'link',
                name: 'Pagos Recibidos',
                iconClasses: 'fas fa-dollar',
                path: ['reporte/pagos']
            },
            {
                type: 'link',
                name: 'Pagos Atrasados y Proximos',
                iconClasses: 'fas fa-dollar',
                path: ['reporte/pagos-proximos']
            },
            {
                type: 'link',
                name: 'Alumnos por Grupo',
                iconClasses: 'fa fa-list',
                path: ['reporte/alumnos-grupo']
            },
            {
                type: 'link',
                name: 'Firmar',
                iconClasses: 'fas fa-student',
                path: ['adm/sign']
            }
        ]
    },
    {
        type: 'padre',
        name: 'Estudiantes',
        iconClasses: 'far fa-folder',
        children: [
            {
                type: 'link',
                name: 'Registrar Asistencia',
                iconClasses: 'fas fa-student',
                path: ['students/attendance-check']
            }
        ]
    }
];

export const MENU_2 = [
    {
        name: 'Proceso',
        iconClasses: 'far fa-folder',
        children: [
            {
                name: 'Grupos',
                iconClasses: 'far fa-address-book',
                path: ['/adm/grupo']
            },
            {
                name: 'Incripcion',
                iconClasses: 'fas fa-users',
                path: ['adm/inscripcion']
            },
            {
                name: 'Cobro',
                iconClasses: 'fas fa-users',
                path: ['adm/cobro']
            },
            {
                name: 'Catalogo Cursos',
                iconClasses: 'fas fa-list-check',
                path: ['adm/catalogo-cursos']
            }
        ]
    },
    {
        name: 'Catalogos',
        iconClasses: 'fas fa-folder',
        children: [
            {
                name: 'Existencia Producto',
                iconClasses: 'far fa-circle',
                path: ['/catalogos/existencia-producto']
            }
        ]
    },
    {
        name: 'Reportes',
        iconClasses: 'far fa-folder',
        children: [
            {
                name: 'Pagos Atrasados y Proximos',
                iconClasses: 'fas fa-dollar',
                path: ['reporte/pagos-proximos']
            }
        ]
    }

];
